export default {
  namespaced: true,

  state: {
    messageHeader: null,
  },

  getters:{
    messageHeader(state){
      return state.messageHeader;
    }
  },

  mutations: {
    SET_MESSAGEHEADER(state, messageHeader) {
      state.messageHeader = messageHeader;
    }
  }
};
